// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".consent[data-v-c38621c8] {\n  padding: 15px 0;\n}\n.consent span[data-v-c38621c8] {\n  color: rgba(80, 86, 115, 0.8);\n}\n.consent a[data-v-c38621c8] {\n  color: #505673;\n}", ""]);
// Exports
module.exports = exports;
